import React, { useEffect, useRef, useState } from 'react';
import AIChatPopup from './components/ai-chat-box/index.jsx';
import { RootProvider } from './hooks/useRoot.jsx';
import style from './index.module.scss';
import PreviewVideo from './components/preview-video/index.jsx';

const AIChatForConsumer = ({
  children,
  className=''
}) => {
  const [showWin, setShowWin] = useState(false);
  const ballRef = useRef(null);

  useEffect(() => {
    let isDragging = false;
    let offsetX, offsetY;
    let startTime = 0;
    const fnMousedown = (e) => {
      isDragging = true;

      offsetX = e.clientX - ballRef.current.getBoundingClientRect().left;
      offsetY = e.clientY - ballRef.current.getBoundingClientRect().top;
      
      document.body.style.userSelect = 'none';

      startTime = new Date().getTime();
    };

    const fnMouseove = (e) => {
      if (isDragging) {
        let newX = e.clientX - offsetX;
        let newY = e.clientY - offsetY;
  
        newX = (newX / window.innerWidth) * 100;
        newY = (newY / window.innerHeight) * 100;

        ballRef.current.style.left = `${newX}vw`;
        ballRef.current.style.top = `${newY}vh`;
      }
    };

    const fnMouseup = () => {
      isDragging = false;
      document.body.style.userSelect = '';
      const curTime = new Date().getTime();
      if(curTime - startTime <= 200) {
        setShowWin(true);
      }
    };

    if(ballRef.current) {
      ballRef.current.addEventListener('mousedown', fnMousedown);
    
      document.addEventListener('mousemove', fnMouseove);
    
      document.addEventListener('mouseup', fnMouseup);
    }

    return () => {
      if(ballRef.current) {
        ballRef.current.removeEventListener('mousedown', fnMousedown);
    
        document.removeEventListener('mousemove', fnMouseove);
      
        document.removeEventListener('mouseup', fnMouseup);
      }
    };
  }, [ballRef]);

  return <>
    <div className={`${className}`}>
      {
        children ? children : <div className={style.bubbleBox} ref={ballRef} id="bubbleBoxForChat">
          <span className={style.bubbleText}>ASK GPT</span>
        </div>
      }
    </div>
    <RootProvider>
      <AIChatPopup showWin={showWin} setShowWin={setShowWin}></AIChatPopup>
      <PreviewVideo></PreviewVideo>
    </RootProvider>
  </>;
};

export default AIChatForConsumer;